import { type ModuleManifest } from '@/lib/modules/types'

const validateReferralTreeSearch = (raw: Record<string, unknown>) => ({
  domain_slug:
    typeof raw.domain_slug === 'string' ? raw.domain_slug : undefined,
  max_depth: typeof raw.max_depth === 'string' ? raw.max_depth : undefined,
})

/**
 * Peitho admin module — `/peitho/*` on console.francisquini.ai.
 *
 * Five subroutes: home, waitlist, referrals, referral programs detail,
 * referral tree. Each page is lazy-loaded via the `@/routes/_app/peitho`
 * Suspense shims (same indirection the static router.ts blocks used) so
 * the Cuidari first-paint bundle does not ship admin code.
 *
 * Surface is `'admin'` — the route builder mounts these only on the
 * console host. RequireAdmin gates live inside each page component
 * (defence-in-depth on top of the host split).
 *
 * Introduced in T9.7 alongside the manifest-driven router builder. The
 * previous static blocks in `src/router.ts` are deleted in the same PR.
 */
export const manifest: ModuleManifest = {
  module_id: 'peitho',
  display_name: 'Peitho',
  surface: 'admin',
  routes: [
    {
      path: '/peitho',
      component: () =>
        import('@/routes/_app/peitho').then((m) => ({
          default: m.PeithoHomePage,
        })),
      title: 'Peitho',
      permissions: [],
    },
    {
      path: '/peitho/waitlist',
      component: () =>
        import('@/routes/_app/peitho').then((m) => ({
          default: m.PeithoWaitlistPage,
        })),
      title: 'Waitlist',
      permissions: [],
    },
    {
      path: '/peitho/referrals',
      component: () =>
        import('@/routes/_app/peitho').then((m) => ({
          default: m.PeithoReferralsPage,
        })),
      title: 'Referrals',
      permissions: [],
    },
    {
      path: '/peitho/referrals/programs/$program_id',
      component: () =>
        import('@/routes/_app/peitho').then((m) => ({
          default: m.PeithoReferralProgramPage,
        })),
      title: 'Referral program',
      permissions: [],
    },
    {
      path: '/peitho/referrals/tree/$user_id',
      component: () =>
        import('@/routes/_app/peitho').then((m) => ({
          default: m.PeithoReferralTreePage,
        })),
      title: 'Referral tree',
      permissions: [],
      validateSearch: validateReferralTreeSearch,
    },
  ],
}
